module.exports = function (fox, v) {
	var alias = 'mandatory';

	var Validator_Mandatory = function() {
		this._alias = alias;
	};

	v._.registerHelper(alias, fox.extend(Validator_Mandatory, fox.mixin({
		validate: function() {
			return !((this._value === '') || (this._value === null));
		}
	}, v._.getBaseHelper()), null, 'Validator_Mandatory'));
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/validator/validators/mandatory.js
// module id = 234
// module chunks = 0